(() => {
  const selector = 'input[data-wiredup-order-multiple]';

  const normalize = (input) => {
    const multiple = Number(input.dataset.wiredupOrderMultiple) || 1;
    const value = Math.max(0, Number.parseInt(input.value, 10) || 0);

    if (multiple > 1 && value > 0 && value % multiple !== 0) {
      input.value = String(Math.ceil(value / multiple) * multiple);
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches(selector)) {
        normalize(event.target);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      event.target.querySelectorAll(selector).forEach(normalize);
    },
    true
  );
})();